<template>
	<el-drawer
    :modal="true"
    :modal-append-to-body="true"
    :visible.sync="show"
    :close-on-click-modal="false"
    :direction="direction"
    :show-close="true"
    :close-on-press-escape="true"
    :before-close="clickCancel"
    class="auto_group_dialog"
    :wrapperClosable="false"
		:with-header="false">
		<header>
  		<span><i></i>自动分组</span>
  	</header>
  	<section>
  		<div class="to_group">
  			待分组人数：{{toGroupNum}}
  		</div>
  		<div class="post">
  			<p>岗位：</p>
  			<div class="post_list">
  				<li v-for="item in postList" v-if="postList.length">{{item.name}}</li>
  				<li v-else>暂无岗位</li>
  			</div>
  		</div>
  		<div class="post group_num">
  			<p>每组人数：</p>
  			<el-input v-model.trim="peopleNum" autocomplete="off"></el-input>
  		</div>
  		<p class="notes">注：每组人数不能超过岗位数，小组成员岗位自动分配，支持一人多岗位。</p>
  	</section>
  	<footer>
  		<div class="btn">
  			<el-button @click="clickCancel">取消</el-button>
      	<el-button type="primary" @click="submitForm()">保存</el-button>
  		</div>
  	</footer>
  </el-drawer>
</template>

<script>
	import * as api from "../../../../api/individualApi";
	export default {
		props:{
			showAutoGroup:{
	      type:Boolean,
	      default:false
	    }
		},
		data(){
			return {
				show: false,
				direction: 'rtl',
				peopleNum:'',
				postList:[],
				toGroupNum:''
			}
		},
		created(){
			
		},
		methods: {
			//获取待分组人数
			getGroupPeopleNum(){
				api.getGroupPeopleNum(this.$route.query.courseId,this.$route.query.classId).then(res=>{
					console.log(res);
					if(res.code == 0){
						this.toGroupNum = res.data;
					}
				})
			},
			// 获取岗位
			getMyStation(){
				api.courseStation(this.$route.query.courseId).then(res=>{
					console.log(res);
					if(res.code == 0){
						this.postList = res.data;
					}
				})
			},
			clickCancel(){
				this.show = false;
				this.$emit('cancelAutoGroup')
				this.peopleNum = '';
			},
			submitForm(){
				if(this.toGroupNum > 0) {
					let judgeN = this.judgeNumber(this.peopleNum);
					if(judgeN){
						if(Number(this.toGroupNum) >= Number(this.peopleNum)){
							if(this.postList.length >= this.peopleNum){
								this.show = false;
								this.$emit('confirmAutoGroup',this.peopleNum);
								this.peopleNum = '';
							}else{
								this.$messageError('每组人数不能超过岗位数');
							}
						}else{
							this.$messageError('每组人数不能超过待选人数');
						}
					}else{
						this.$messageError('每组人数不能为空并且为正整数');
					}
				}else{
					this.$messageError('暂无待分组学员');
				}
			},
			// 正整数正则
			judgeNumber(num){
				var reg = /^[1-9]\d*$/;
				return reg.test(num);
			}
		},
		watch: {
			showAutoGroup(val){
				this.show = val;
			}
		}
	}
</script>

<style scoped lang="scss">
	.auto_group_dialog {
		/deep/ .el-drawer {
			width: 36% !important;
		}
		header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 64px;
      border-bottom: 2px solid #DDE0E2;
      padding: 0 20px;
      span {
        font-size: 16px;
        color: #0D141E;
        i {
          display: inline-block;
          width:4px;
          height:12px;
          background:rgba(83,151,247,1);
          margin-right: 8px;
        }
      }
    }
    section {
    	padding: 16px 26px;
    	.to_group {
    		color: #0D141E;
    		font-size: 14px;
    		margin-bottom: 25px;
    	}
    	.post {
    		p {
    			color: #0D141E;
    			font-size: 12px;
    			margin-bottom: 11px;
    		}
    		.post_list {
    			display: flex;
    			flex-flow: wrap;
    			li {
    				width:96px;
						height:24px;
						background:rgba(83,151,247,1);
						border-radius:2px;
						color: #fff;
						font-size: 12px;
						line-height: 24px;
						text-align: center;
						margin-right: 8px;
						margin-bottom: 8px;
    			}
    		}
    	}
    	.group_num {
    		p {
    			margin-top: 18px;
    		}
    		/deep/ .el-input {
    			.el-input__inner {
    				height: 32px;
    				line-height: 32px;
    				border: 0;
    				background: #F1F2F4;
    			}
    		}
    	}
    	.notes {
    		font-size: 13px;
    		color: #858C96;
    		margin-top: 16px;
    	}
    }
    footer {
    	.btn {
    		text-align: center;
    		.el-button {
    			padding: 6px 21px;
    		}
    	}
    }
	}
</style>


// WEBPACK FOOTER //
// src/components/views/TeachClass/components/autoGroup.vue